<template>
    <transition enter-active-class="animated zoomInRight" leave-active-class="animated zoomOutUp">
        <sub-page class="mapDetailPage" :title="title" :closeFn="closeFile" v-if="subPage">

            <div class="map-info">
                <div style="flex:1">
                    <p>{{$t('c.name')}}：{{subData.byName}}</p>
                    <p>{{$t('c.knowledgePoint')}}：{{subData.knowledgeName}}</p>
                    <p>{{$t('res.imgType')}}：{{subData.typeName}}</p>
                    <p>{{$t('res.imgDesc')}}：{{subData.description}}</p>
                </div>
                <el-button-group style="padding-right: 10px">
                    <el-button v-if="canEdit" type="success" size="small" @click="editImage">
                        <i class="nucfont inuc-edit"></i> {{$t('c.edit')}}
                    </el-button>
                    <el-button type="primary" size="small" @click="viewImage">
                        <i class="nucfont inuc-preview"></i> {{isDR ? $t('res.viewDR'): $t('res.viewCT')}}
                    </el-button>
                </el-button-group>
            </div>

            <el-carousel
                ref="mapCarousel"
                class="map-carousel"
                :autoplay="false"
                height="100%"
                arrow="always"
                @change="imgChange"
            >
                <el-carousel-item v-for="item in subImgArr" :key="item.url">
                    <img :src="item.url" alt="">
                </el-carousel-item>

                <template v-if="subData.thumbnails && subData.physicalMaps">
                    <div class="prev-file" @click="toPrevFile"
                         v-show="carouselIndex===0">
                        <p>{{$t('res.lastFile')}}</p>
                    </div>
                    <div class="next-file" @click="toNextFile"
                         v-show="carouselIndex===subData.thumbnails.length+subData.physicalMaps.length-1 || subData.thumbnails.length+subData.physicalMaps.length===0">
                        <p>{{$t('res.nextFile')}}</p>
                    </div>
                    <div class="no-thumb" v-if="subData.thumbnails.length+subData.physicalMaps.length===0">
                        <img src="../../assets/images/map/no-img.png" alt="">
                    </div>
                </template>
            </el-carousel>

            <ul class="thumb-list">
                <li class="thumb-item"
                    :class="{'active': carouselIndex === index}"
                    v-for="(item, index) in subImgArr"
                    @click="thumbClick(index)"
                    :key="index">
                    <img :src="item.url" alt="">
                </li>
            </ul>

            <!-- edit dialog -->
            <el-dialog
                :title="$t('res.editImg')"
                :visible.sync="editDialog"
                width="450px"
                :close-on-click-modal="false"
                :modal-append-to-body="false"
            >
                <el-form
                    :model="editForm"
                    :rules="editRule"
                    class="edit-form"
                    ref="editForm"
                    label-width="100px">
                    <el-form-item :label="$t('c.name')+'：'" prop="byName">
                        <el-input v-model="editForm.byName" :placeholder="$t('tip.name')" clearable></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('c.description')+'：'">
                        <el-input type="textarea" v-model="editForm.description"
                                  :autosize="{ minRows: 3, maxRows: 4}"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" style="text-align: center">
                    <el-button type="primary" @click="saveMenuForm" :loading="editLoading">{{$t('c.save')}}</el-button>
                </div>
            </el-dialog>
        </sub-page>
    </transition>

</template>

<script>
    import SubPage from '@/components/Subpage.vue'

    export default {
        components: {
            SubPage
        },
        props: {
            isDR: true,
            subPage: false
        },
        data() {
            return {
                title: '',
                subData: {},
                carouselIndex: 0,

                //edit
                editDialog: false,
                editForm: {
                    byName: '',
                    description: ''
                },
                editLoading: false,
                editRule: {
                    byName: [
                        {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                        {max: 50, message: this.$t('rule.maxLength', ['50']), trigger: 'blur'}
                    ]
                },
            }
        },

        computed: {
            listData() {
                return this.$parent.listData
            },
            canEdit() {
                let bool = false
                if (this.isSystemImage &&  this.$parent.userID === this.subData.creator) bool = true
                if (!this.isSystemImage) bool = true
                return bool
            },
            subImgArr() {
                let arr = []

                if (this.subData.thumbnails && this.subData.physicalMaps) {
                    arr = [...this.subData.thumbnails, ...this.subData.physicalMaps]
                }
                return arr
            },
            isSystemImage() {
                return this.$parent.tabIndex == 1
            }
        },

        mounted() {
        },

        methods: {
            init() {
                this.initEvent()
            },

            getImageDetail(id) {
                let api;

                if (this.isSystemImage) {
                    api = this.isDR ? this.$api.getDRDetail(id) : this.$api.getCTDetail(id)
                } else {
                    api = this.isDR ? this.$api.getDRUserImageDetail(id) : this.$api.getCTUserImageDetail(id)
                }

                return api.then(res => {
                    let data = res.package
                    if (data.physicalMaps == null) {
                        data.physicalMaps = []
                    }
                    this.subData = data
                    this.subData.originId = data.id

                    if (!this.isSystemImage) {
                        this.subData.id = data.userImageId
                    }
                    this.title = data.byName
                })
            },

            imgChange(index) {
                this.carouselIndex = index
            },
            thumbClick(index) {
                this.$refs.mapCarousel.setActiveItem(index)
            },
            toPrevFile() {
                let id = this.subData.id
                let index = this.listData.findIndex(ele => ele.id === id || ele.userImageId === id)
                let prevIndex = index - 1

                if (index === 0) {
                    prevIndex = this.listData.length - 1
                }

                let prevId = this.isSystemImage? this.listData[prevIndex].id : this.listData[prevIndex].userImageId
                this.getImageDetail(prevId).then(d => {
                    this.imgChange(0)
                })
            },
            toNextFile() {
                let id = this.subData.id
                let index = this.listData.findIndex(ele => ele.id === id || ele.userImageId === id)
                let nextIndex = index + 1

                if (index === this.listData.length - 1) {
                    nextIndex = 0
                }
                /**
                 *   index重置为0，这里不使用this.imgChange(0)是因为
                 *    如果index之前不为0，而重置为0，会自动调用this.imgChange()，从而调用了2次产生问题。
                 */
                let nextId = this.isSystemImage? this.listData[nextIndex].id : this.listData[nextIndex].userImageId
                this.getImageDetail(nextId).then(d => {
                    this.$refs.mapCarousel.setActiveItem(0)
                })
            },

            viewImage() {
                this.$emit('viewImage', this.subData.originId)
            },
            editImage() {
                this.$emit('editImage', this.subData, 'inner')
            },

            initEvent() {
                $(document).off()

                // 上下翻文件 l37 r39
                $(document).keydown(e => {
                    let key = e.keyCode

                    // 上
                    if (key === 38) {
                        this.toPrevFile()
                    }

                    // 下
                    if (key === 40) {
                        this.toNextFile()
                    }

                    // 左
                    if (key === 37) {
                        if (this.carouselIndex === 0) {
                            this.toPrevFile()
                        } else {
                            this.thumbClick(this.carouselIndex - 1)
                        }
                    }

                    // 右
                    if (key === 39) {
                        if (this.carouselIndex === this.subData.thumbnails.length + this.subData.physicalMaps.length - 1
                            || this.subData.thumbnails.length + this.subData.physicalMaps.length === 0) {
                            this.toNextFile()
                        } else {
                            this.thumbClick(this.carouselIndex + 1)
                        }
                    }
                })
            },

            closeFile() {
                this.$emit('update:subPage', false)

            },
        },

        watch: {
            subPage(v) {
                if (v) this.init()
            }
        },

        beforeDestroy() {
            $(document).off()
        }
    }
</script>

<style scoped lang="scss">
    @import '~@/style/const.scss';

    .mapDetailPage {
        .map-info {
            display: flex;
            margin: -5px 0 15px 10px;
            line-height: 22px;
        }

        .map-carousel {
            flex: 1;
            margin: 0 10px;
            border: 1px solid #ebeef5;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }

        .el-carousel__item {
            display: flex;
            justify-content: center;
            align-items: center;

            > img {
                width: 90%;
                height: 90%;
                object-fit: contain ;
            }
        }

        .thumb-list {
            margin-left: 10px;
            @include clearfix();

            .thumb-item {
                display: flex;
                justify-content: center;
                align-items: center;
                float: left;
                width: 120px;
                height: 100px;
                margin-top: 15px;
                margin-right: 10px;
                border: 1px solid #d3dce6;
                transition: all .3s;
                cursor: pointer;

                &:hover {
                    transform: translateY(-3px);

                    img {
                        transform: scale(1.05);
                        transition: all .3s;
                    }
                }

                &.active {
                    border-color: #00bcd4;
                }
            }

            img {
                max-width: 90%;
                max-height: 90%;
            }
        }

        .prev-file, .next-file {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 80px;
            z-index: 10;
            background-color: #efefef;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: 0 5px 20px 2px #efefef;

            &:hover {
                box-shadow: 0 5px 20px 3px #ddd;
            }
        }

        .prev-file {
            left: 0;
        }

        .next-file {
            right: 0;
        }

        .no-thumb {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            > img {
                width: 200px;
            }
        }
    }
</style>
